class AEMobileNavigation extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('.ae-mobile-trigger');
    this.dialog = this.querySelector('.ae-mobile-dialog');
    this.panel = this.querySelector('.ae-mobile-panel');
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.desktop = matchMedia('(min-width: 1200px)');
    this.animations = new Map();
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.trigger.addEventListener('click', () => this.open(), options);
    this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.close(); }, options);
    this.dialog.querySelectorAll('[data-mobile-close]').forEach((button) => button.addEventListener('click', () => this.close(), options));
    this.dialog.querySelectorAll('[data-mobile-toggle]').forEach((button) => button.addEventListener('click', () => this.toggle(button), options));
    this.dialog.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => this.close(true), options));
    this.desktop.addEventListener('change', () => { if (this.desktop.matches) this.close(true); }, options);
  }
  open() {
    if (this.dialog.open || this.desktop.matches) return;
    clearTimeout(this.closeTimer);
    this.dialog.showModal();
    this.trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('ae-navigation-locked');
    // Establish the closed position before the opening transition starts.
    this.panel.getBoundingClientRect();
    this.dialog.classList.add('is-open');
    if (!this.reduced.matches) this.dialog.querySelectorAll('[data-mobile-root]').forEach((item, index) => {
      item.getAnimations().forEach((animation) => animation.cancel());
      item.animate({ opacity: [0, 1], transform: ['translateX(-40px)', 'translateX(0)'] }, {
        duration: 200, delay: Math.min(20 * index, 100),
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)', fill: 'backwards'
      });
    });
  }
  close(immediate = false) {
    if (!this.dialog.open) return;
    this.dialog.classList.remove('is-open');
    this.trigger.setAttribute('aria-expanded', 'false');
    clearTimeout(this.closeTimer);
    const finish = () => {
      this.dialog.close();
      document.body.classList.remove('ae-navigation-locked');
    };
    if (immediate || this.reduced.matches) finish();
    else this.closeTimer = setTimeout(finish, 250);
  }
  toggle(button) {
    const content = this.dialog.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
    const opening = button.getAttribute('aria-expanded') !== 'true';
    const startHeight = content.hidden ? 0 : content.getBoundingClientRect().height;
    this.animations.get(content)?.cancel();
    content.hidden = false;
    content.inert = !opening;
    button.setAttribute('aria-expanded', String(opening));
    if (this.reduced.matches) { content.hidden = !opening; content.style.overflow = ''; return; }
    content.style.overflow = 'hidden';
    const animation = content.animate({ height: [`${startHeight}px`, opening ? `${content.scrollHeight}px` : '0px'] }, {
      duration: 250, easing: 'cubic-bezier(0.75, 0, 0.175, 1)'
    });
    this.animations.set(content, animation);
    animation.onfinish = () => {
      content.hidden = !opening;
      content.style.overflow = '';
      this.animations.delete(content);
    };
  }
  disconnectedCallback() {
    this.close(true);
    this.abort?.abort();
    this.animations?.forEach((animation) => animation.cancel());
    clearTimeout(this.closeTimer);
  }
}
if (!customElements.get('ae-mobile-navigation')) customElements.define('ae-mobile-navigation', AEMobileNavigation);
